import { Component } from '@angular/core';

@Component({
  selector: 'app-excel-reports',
  standalone: true,
  imports: [],
  templateUrl: './excel-reports.component.html',
  styleUrl: './excel-reports.component.scss'
})
export class ExcelReportsComponent {

}
